<template>
	<div class="FileIcon svgIcon" :style="{ width: size + 'px', height: size + 'px' }">
		<svg class="MuiSvgIcon-root wiznote-label-icon jss211 jss202" focusable="false" viewBox="0 0 24 24" aria-hidden="true" :width="size" :height="size">
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M19.64 9.43825L19.6392 10.0105L4 10.0101V8.13533C4 7.42597 4.17378 6.89274 4.52133 6.53564C4.86889 6.17855 5.35402 6 5.97672 6H7.92448C8.15619 6 8.35651 6.01568 8.52546 6.04705C8.69441 6.07842 8.85009 6.1327 8.99249 6.20991C9.13489 6.28712 9.28574 6.38846 9.44504 6.51393L9.84328 6.8469C10.0267 6.99649 10.2017 7.10265 10.3682 7.16539C10.5348 7.22812 10.7363 7.25949 10.9728 7.25949H17.4316C18.1605 7.25949 18.7108 7.44286 19.0825 7.80961C19.4542 8.17635 19.64 8.71923 19.64 9.43825ZM4.55754 18.1135C4.18585 17.7492 4 17.2051 4 16.4812V10.9583H19.6392L19.64 16.4812C19.64 17.2003 19.4626 17.7431 19.1078 18.1099C18.753 18.4766 18.257 18.66 17.6198 18.66H6.20843C5.47952 18.66 4.92923 18.4778 4.55754 18.1135Z"
				fill="url(#folder_selected_paint0_linear)"
			></path>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M19.64 9.43825L19.6392 10.0105L4 10.0101V8.13533C4 7.42597 4.17378 6.89274 4.52133 6.53564C4.86889 6.17855 5.35402 6 5.97672 6H7.92448C8.15619 6 8.35651 6.01568 8.52546 6.04705C8.69441 6.07842 8.85009 6.1327 8.99249 6.20991C9.13489 6.28712 9.28574 6.38846 9.44504 6.51393L9.84328 6.8469C10.0267 6.99649 10.2017 7.10265 10.3682 7.16539C10.5348 7.22812 10.7363 7.25949 10.9728 7.25949H17.4316C18.1605 7.25949 18.7108 7.44286 19.0825 7.80961C19.4542 8.17635 19.64 8.71923 19.64 9.43825ZM4.55754 18.1135C4.18585 17.7492 4 17.2051 4 16.4812V10.9583H19.6392L19.64 16.4812C19.64 17.2003 19.4626 17.7431 19.1078 18.1099C18.753 18.4766 18.257 18.66 17.6198 18.66H6.20843C5.47952 18.66 4.92923 18.4778 4.55754 18.1135Z"
				fill="url(#folder_selected_paint1_linear)"
			></path>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M19.64 9.43825L19.6392 10.0105L4 10.0101V8.13533C4 7.42597 4.17378 6.89274 4.52133 6.53564C4.86889 6.17855 5.35402 6 5.97672 6H7.92448C8.15619 6 8.35651 6.01568 8.52546 6.04705C8.69441 6.07842 8.85009 6.1327 8.99249 6.20991C9.13489 6.28712 9.28574 6.38846 9.44504 6.51393L9.84328 6.8469C10.0267 6.99649 10.2017 7.10265 10.3682 7.16539C10.5348 7.22812 10.7363 7.25949 10.9728 7.25949H17.4316C18.1605 7.25949 18.7108 7.44286 19.0825 7.80961C19.4542 8.17635 19.64 8.71923 19.64 9.43825ZM4.55754 18.1135C4.18585 17.7492 4 17.2051 4 16.4812V10.9583H19.6392L19.64 16.4812C19.64 17.2003 19.4626 17.7431 19.1078 18.1099C18.753 18.4766 18.257 18.66 17.6198 18.66H6.20843C5.47952 18.66 4.92923 18.4778 4.55754 18.1135Z"
				fill="url(#folder_selected_paint2_linear)"
			></path>
			<defs>
				<linearGradient id="folder_selected_paint0_linear" x1="-5.58162" y1="12.33" x2="6.30452" y2="30.3219" gradientUnits="userSpaceOnUse">
					<stop stop-color="#3D9AFF"></stop>
					<stop offset="1" stop-color="#772DFF"></stop>
				</linearGradient>
				<linearGradient id="folder_selected_paint1_linear" x1="0.137054" y1="10.7285" x2="8.87047" y2="25.1719" gradientUnits="userSpaceOnUse">
					<stop stop-color="#64BAFB"></stop>
					<stop offset="1" stop-color="#655FFF"></stop>
				</linearGradient>
				<linearGradient id="folder_selected_paint2_linear" x1="-5.58162" y1="12.33" x2="6.30452" y2="30.3219" gradientUnits="userSpaceOnUse">
					<stop stop-color="#06D3FF"></stop>
					<stop offset="1" stop-color="#8247FF"></stop>
				</linearGradient>
			</defs>
		</svg>
	</div>
</template>
<script setup name="FileIcon">
	let props = defineProps({
		size: {
			type: [Number,String],
			default: () => 24
		}
	})
</script>
<style scoped lang="less">
	.FileIcon,
	.svgIcon {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}
</style>
